/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_Cta_PrimaryInputs */

const en_mk_studio_cta_primary = /** @type {(inputs: Mk_Studio_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Studio waitlist`)
};

const id_mk_studio_cta_primary = /** @type {(inputs: Mk_Studio_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar waitlist Studio`)
};

/**
* | output |
* | --- |
* | "Join the Studio waitlist" |
*
* @param {Mk_Studio_Cta_PrimaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_cta_primary = /** @type {((inputs?: Mk_Studio_Cta_PrimaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_Cta_PrimaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_cta_primary(inputs)
	return en_mk_studio_cta_primary(inputs)
});